import React, { useState, useContext } from 'react';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import AlarmGrid from '../molecules/Grid/AlarmGrid';
import PLSStateCard from '../molecules/Card/PLSStateCard';
import CloudErrorLogCard from '../molecules/Card/CloudErrorLogCard';
import TimeCard from '../molecules/Card/TimeCard';
import LanguageChangeCardEx from '../molecules/Card/LanguageChangeCardEx';
import AppTitleCard from '../molecules/Card/AppTitleCard';
import UserNameCard from '../molecules/Card/UserNameCard';
import { AppContext } from '../../App';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  createStyles({
    spacingXs1: {
      minWidth: '1440px',
    },
  })
);

const Header: React.FC = () => {
  const { login } = useContext(AppContext);
  const classes = useStyles();

  return (
    <>
      {login.IsIoT ? (
        <Grid container spacing={1} classes={{ 'spacing-xs-1': classes.spacingXs1 }}>
          <Grid item xs={4}>
            <AppTitleCard />
          </Grid>
          <Grid item xs={2}>
            <CloudErrorLogCard />
          </Grid>
          <Grid item xs={2}>
            <TimeCard />
          </Grid>
          <Grid item xs={2}>
            <LanguageChangeCardEx />
          </Grid>
          <Grid item xs={2}>
            <UserNameCard />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={1} classes={{ 'spacing-xs-1': classes.spacingXs1 }}>
          <Grid item xs={5}>
            <AppTitleCard />
          </Grid>
          <Grid item xs={1}>
            <PLSStateCard />
          </Grid>
          <Grid item xs={2}>
            <TimeCard />
          </Grid>
          <Grid item xs={2}>
            <LanguageChangeCardEx />
          </Grid>
          <Grid item xs={2}>
            <UserNameCard />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Header;
